import type { ServerErrorCode } from '../server-error-codes';
import type { ApiErrorResponse } from './api-error-types';

const API_ERROR_MESSAGE_TO_CODE_MAP: Record<string, ServerErrorCode> = {
  NAME_ALREADY_EXISTS: 'NAME_ALREADY_EXISTS',
  TOO_MANY_RECURRING_REPORTS: 'TOO_MANY_RECURRING_REPORTS',
  INVALID_METRIC_COMBINATION: 'INVALID_METRIC_COMBINATION',
  REPORT_TOO_LARGE: 'REPORT_TOO_LARGE',
  TOO_MANY_SELECTIONS: 'TOO_MANY_SELECTIONS',
  INVALID_DATE_RANGE: 'INVALID_DATE_RANGE'
};

const HTTP_STATUS_TO_CODE_MAP: Record<number, ServerErrorCode> = {
  400: 'UNKNOWN',
  401: 'UNKNOWN',
  403: 'UNKNOWN',
  404: 'NOT_FOUND',
  413: 'UNKNOWN',
  429: 'TOO_MANY_REQUESTS',
  500: 'UNKNOWN'
};

export const mapApiErrorToServerCode = (error: ApiErrorResponse): ServerErrorCode => {
  if (error.data?.message && error.data.message in API_ERROR_MESSAGE_TO_CODE_MAP) {
    return API_ERROR_MESSAGE_TO_CODE_MAP[error.data.message];
  }

  return HTTP_STATUS_TO_CODE_MAP[error.status] || 'UNKNOWN';
};
